import { useParams } from 'react-router-dom';
import { featuredOnly, HomepageOption } from "../../model";
import HeroHeadline from "../HeroHeadline/HeroHeadline";
import QuadrantGrid from "../QuadrantGrid/QuadrantGrid";
import RadarGrid from '../RadarGrid/RadarGrid';
import SetTitle from "../SetTitle";
import { radarNameShort } from "../../config";
import { useRadarConfiguration } from "../../hooks/UseRadarConfiguration";
import { dataConfigTransform } from "../../contentful/transformers/config/config";
import { dataRadarTransform } from "../../contentful/transformers/radar/radar";


export default function PageIndex() {
  const { radarName } = useParams();
  const { data: radarData } = useRadarConfiguration(radarName);

  const data = radarData && dataRadarTransform(radarData);
  const config = radarData && dataConfigTransform(radarData);

  const showChart = config?.homepageContent === HomepageOption.chart || config?.homepageContent === HomepageOption.both;
  const showColumns = config?.homepageContent === HomepageOption.columns || config?.homepageContent === HomepageOption.both;
  return (
    <>
      <SetTitle title={radarNameShort} /> 
      <div className="headline-group">
        <HeroHeadline alt={``}>
          {config?.title}
        </HeroHeadline>
      </div>
      {showChart && (
        <RadarGrid items={featuredOnly(data?.items ?? [])} config={config} />
      )}
      {showColumns && (
        <QuadrantGrid items={featuredOnly(data?.items ?? [])} config={config} />
      )}
    </>
  );
}
